interface AppConfig {
  UserName?: string;
  Password?: string;
  REACT_APP_HOST_URL?: string;
  REACT_APP_DEPLOYMENT_URL: string;
  INTERNAL_GATEWAY_URL: string;
  GCP_IMAGES_BUCKET?: string;
  authMode?: "manual-login" | "auto-login";
  tenantId?: string;
  AMPLITUDE_API_KEY?: string;
  paymobPublicKey?:string;
}

const developingAppConfig: AppConfig = {
  UserName: "Omar22",
  Password: "Om@1111",
  authMode: "auto-login",
  REACT_APP_DEPLOYMENT_URL: "http://localhost:4212/",
  INTERNAL_GATEWAY_URL: "https://staging-reward-catalog-api.dsquares.com/api",
  GCP_IMAGES_BUCKET: "https://storage.googleapis.com/dsq-staging/staging/platform/payment/images/",
  tenantId: "Staging",
  AMPLITUDE_API_KEY: "5489e513ccd6442a8eb32e7df6c3c438",
  paymobPublicKey: "egy_pk_test_o15Y67o27QxrK54hfWjzz0MDKZDuOiUn",
};

const stagingAppConfig: AppConfig = {
  UserName: "Omar22",
  Password: "Om@1111",
  authMode: "auto-login",
  REACT_APP_DEPLOYMENT_URL: "https://rc-webview-staging.dsquares.com/",
  INTERNAL_GATEWAY_URL: "https://staging-reward-catalog-api.dsquares.com/api",
  GCP_IMAGES_BUCKET: "https://storage.googleapis.com/dsq-staging/staging/platform/payment/images/",
  tenantId: "Staging",
  AMPLITUDE_API_KEY: "5489e513ccd6442a8eb32e7df6c3c438",
  paymobPublicKey: "egy_pk_test_o15Y67o27QxrK54hfWjzz0MDKZDuOiUn",
};

const preprodAppConfig: AppConfig = {
  authMode: "manual-login",
  REACT_APP_DEPLOYMENT_URL: "https://rc-webview-preprod.dsquares.com/",
  INTERNAL_GATEWAY_URL: "https://preprod-reward-catalog-api.dsquares.com/api",
  GCP_IMAGES_BUCKET: "https://storage.googleapis.com/dsq-prod/PreProd/platform/payment/images/providers/",
  AMPLITUDE_API_KEY: "5489e513ccd6442a8eb32e7df6c3c438",
  paymobPublicKey: "egy_pk_test_o15Y67o27QxrK54hfWjzz0MDKZDuOiUn",
};

const prodAppConfig: AppConfig = {
  authMode: "manual-login",
  REACT_APP_DEPLOYMENT_URL: "https://rc-webview.dsquares.com/",
  GCP_IMAGES_BUCKET: "https://storage.googleapis.com/dsq-prod/Prod/platform/product-api/images/",
  INTERNAL_GATEWAY_URL: "https://reward-catalog-api.dsquares.com/api",
  AMPLITUDE_API_KEY: "5489e513ccd6442a8eb32e7df6c3c438",
  paymobPublicKey: "egy_pk_test_o15Y67o27QxrK54hfWjzz0MDKZDuOiUn",
};

type Environment = "staging" | "preproduction" | "production" | "development";

const appConfig: Record<Environment, AppConfig> = {
  development: developingAppConfig,
  staging: stagingAppConfig,
  preproduction: preprodAppConfig,
  production: prodAppConfig,
};

const env = (process.env.DEPLOYMENT_ENV as Environment) || "development";

export default appConfig[env];
